import { render, staticRenderFns } from "./ArchiveEmptyStateIcon.vue?vue&type=template&id=66c2e1d5&"
import script from "./ArchiveEmptyStateIcon.vue?vue&type=script&lang=js&"
export * from "./ArchiveEmptyStateIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports